/* eslint-disable */
import {
    Box,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Stack,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useContext, useEffect, useRef, useState } from "react";
  import SearchIcon from "@mui/icons-material/Search";
  import { getSearchUniversityDetails } from "../../services";
  import { useNavigate } from "react-router-dom";
  import { Event, FilterProps, FilterSelected } from "../../types/types";
//   import { filterOptions } from "../../assets/menu";
  import Context from "../../assets/constants/context";
  import CloseIcon from '@mui/icons-material/Close';
  interface option {
    location?:
    {
      country: string;
      state: string;
      city: string;
    };
    _id: string;
    name: string;
    logoSrc: string;
    community: string;
  }
  const Search = ({ appliedFilter, setAppliedFilter, setAnchorElNav }: FilterProps) => {
    const navigate = useNavigate();
    const [options, setOptions] = useState<any[]>([]);
    const [courseoptions, setCourseOptions] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [subDisciplines, setsubDisciplines] = useState([]);
    const [country, setCountry] = useState([]);
    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const listRef = useRef<HTMLUListElement | null>(null);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    const { selectedUniversities, setSelectedUniversities } = useContext(Context);
    const [selectedIndex, setSelectedIndex] = useState<{ type: string; index: number }>({ type: "", index: -1 });
    const [search, setSearch] = useState(true)
    const getUniversity = async (searchTerm: string) => {
      // setLoading(true);
      const trimSearch = searchTerm?.trim()
      if (trimSearch !== "") {
        try {
          const response = await getSearchUniversityDetails(trimSearch, 1, 8, 0, 1, 1, 1, 1);
          // setLoading(false);
          // console.log(response.data?.universities)
          setOptions(response.data?.universities);
          setCourseOptions(response.data?.courses);
          setDisciplines(response.data?.disciplines);
          setsubDisciplines(response.data?.subDisciplines);
          setCountry(response.data?.country)
          setCity(response.data?.city)
          setState(response.data?.state)
        } catch (error) { }
  
      }
    };
  
    const onSelection = (data: FilterSelected) => {
      let filterdata: FilterSelected = data;
      let filterindex = appliedFilter.findIndex((filter) => filter.type === data.type)
      if (filterdata.data.length != 0) {
        if (filterindex == -1) {
          setAppliedFilter([...appliedFilter, filterdata])
        }
        else {
          let temp = [...appliedFilter];
          temp.splice(filterindex, 1, filterdata)
          appliedFilter = temp
        }
      }
      else {
        setAppliedFilter([...appliedFilter.filter((filter) => filter.type !== data.type)])
      }
    };
  
    const eventHandler = (event: Event) => {
      switch (event.name) {
        case "inputChange":
          const searchTerm = event.data.target.value;
          setSearchValue(searchTerm);
          if (timer) {
            clearTimeout(timer);
          }
          if (event.data.target.value !== "") {
            const newTimer = setTimeout(() => {
              getUniversity(searchTerm);
            }, 200);
            setTimer(newTimer);
          } else {
            setOptions([]);
            setDisciplines([]);
            setsubDisciplines([]);
            setCountry([]);
            setState([]);
            setCity([]);
          }
          setSearchValue(event.data.target.value);
          setMenuOpen(true);
          break;
  
        case "clicksearch":
          const search = event.data.target.value;
          setSearchValue(search);
          if (event.data.target.value !== "") {
            getUniversity(search);
          } else {
            setOptions([]);
            setDisciplines([]);
            setsubDisciplines([]);
            setCountry([]);
            setState([]);
            setCity([]);
          }
          break;
  
        case "focus":
          if (searchValue) {
            setMenuOpen(true);
          }
          break;
  
        case "keypress":
          if (
            event.data.key === "Enter" &&
            event.data.target.value.trim() !== ""
          ) {
            event.data.preventDefault();
            sessionStorage.setItem(
              "courseSearch",
              event.data.target.value.trim()
            );
            onSelection({
              type: "name",
              data: event.data.target.value.trim(),
            });
            setOptions([]);
            setMenuOpen(false);
            setDisciplines([]);
            setSearchValue("");
            setsubDisciplines([]);
            setCountry([]);
            setState([]);
            setCity([]);
            // navigate("/explore");
            if (setAnchorElNav) {
              setAnchorElNav(null)
            }
            // navigate(`/explore?activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "name", data: [{name:event.data.target.value,value:event.data.target.value.trim()}]}]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`);
            // setAnchorElNav(null)
            const url = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(
              JSON.stringify([{ type: "name", data: [{ name: event.data.target.value, value: event.data.target.value.trim() }] }])
            )}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`;
  
            const encodedUrl = window.btoa(url);
            navigate(`/explore?${encodedUrl}`);
          }
          break;
  
        case "optionChange":
          onSelection({ type: "universityId", data: [{ name: event.data?.name, value: event.data?._id }] });
          const newSelectedOption = [...selectedUniversities, event.data];
          setSelectedUniversities(newSelectedOption)
          // console.log("click",event.data)
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          const optionUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${JSON.stringify([{ type: "universityId", data: [{ name: event.data?.name, value: event.data?._id }] }])}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const Url = window.btoa(optionUrl);
          navigate(`/explore?${Url}`);
          //navigate("/explore");
          setMenuOpen(false);
          setSearchValue("");
          // setAnchorElNav(null)
  
          break;
  
        case "disciplineChange":
          onSelection({ type: "discipline", data: event.data });
          const disciplineUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "discipline", data: [{ name: event.data, value: event.data }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const encodedUrl = window.btoa(disciplineUrl);
          navigate(`/explore?${encodedUrl}`);
          setMenuOpen(false);
          setSearchValue("");
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          // setAnchorElNav(null)
  
          break;
  
        case "subDisciplineChange":
          onSelection({ type: "subDiscipline", data: event.data });
          const subDisUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "subDiscipline", data: [{ name: event.data, value: event.data }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const subDisciUrl = window.btoa(subDisUrl);
          navigate(`/explore?${subDisciUrl}`);
          setMenuOpen(false);
          setSearchValue("");
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          // setAnchorElNav(null)
  
          break;
        case "countryChange":
          onSelection({ type: "country", data: event.data });
          const countryUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "country", data: [{ name: event.data, value: event.data }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const encodedcountryUrlUrl = window.btoa(countryUrl);
          navigate(`/explore?${encodedcountryUrlUrl}`);
          setMenuOpen(false);
          setSearchValue("");
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          // setAnchorElNav(null)
  
          break;
        case "stateChange":
          onSelection({ type: "state", data: event.data });
          const stateUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "state", data: [{ name: event.data, value: event.data }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const encodedstateUrlUrl = window.btoa(stateUrl);
          navigate(`/explore?${encodedstateUrlUrl}`);
          setMenuOpen(false);
          setSearchValue("");
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          // setAnchorElNav(null)
  
          break;
        case "cityChange":
          onSelection({ type: "city", data: event.data });
          const cityUrl = `activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "city", data: [{ name: event.data, value: event.data }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`
          const encodedcityUrlUrl = window.btoa(cityUrl);
          navigate(`/explore?${encodedcityUrlUrl}`);
          setMenuOpen(false);
          setSearchValue("");
          if (setAnchorElNav) {
            setAnchorElNav(null)
          }
          // setAnchorElNav(null)
  
          break;
        case "keydown":
          const totalOptions = options.length + disciplines.length + subDisciplines.length;
          const allOptions = [...options, ...disciplines, ...subDisciplines];
          if (event.data.key === "ArrowDown") {
            event.data.preventDefault();
            setSelectedIndex((prevIndex) => {
              const newIndex = prevIndex.index < totalOptions - 1 ? prevIndex.index + 1 : 0;
              return { type: getType(newIndex), index: newIndex };
            });
          } else if (event.data.key === "ArrowUp") {
            event.data.preventDefault();
            setSelectedIndex((prevIndex) => {
              const newIndex = prevIndex.index > 0 ? prevIndex.index - 1 : totalOptions - 1;
              return { type: getType(newIndex), index: newIndex };
            });
          } else if (event.data.key === "Enter" && selectedIndex.index >= 0) {
            const selectedOption = allOptions[selectedIndex.index];
            if (selectedOption) {
              switch (selectedIndex.type) {
                case "university":
                  if (setAnchorElNav) {
                    setAnchorElNav(null)
                  }
                  onSelection({ type: "universityId", data: [{ name: selectedOption, value: selectedOption }] });
                  navigate(`/explore?activeTab=${JSON.stringify("courses")}&FilterData=${JSON.stringify([{ type: "universityId", data: [{ name: selectedOption, value: selectedOption }] }])}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`);
                  break;
                case "discipline":
                  if (setAnchorElNav) {
                    setAnchorElNav(null)
                  }
                  onSelection({ type: "discipline", data: [selectedOption] });
                  navigate(`/explore?activeTab=${JSON.stringify("courses")}&FilterData=${encodeURIComponent(JSON.stringify([{ type: "discipline", data: [{ name: selectedOption, value: selectedOption }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`);
                  break;
                case "subDiscipline":
                  if (setAnchorElNav) {
                    setAnchorElNav(null)
                  }
                  onSelection({ type: "subDiscipline", data: [selectedOption] });
                  navigate(`/explore?activeTab=${JSON.stringify("courses")}&FilterData={encodeURIComponent(JSON.stringify([{ type: "subDiscipline", data: [{ name: selectedOption, value: selectedOption }] }]))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`);
                  break;
                default:
                  break;
              }
            }
            setOptions([]);
            setMenuOpen(false);
            setDisciplines([]);
            setSearchValue("");
            setsubDisciplines([]);
          }
          break;
      }
    };
  
    const renderOption = (option: any) => {
      if (!option) return null;
  
      const label = option.name || option;
      const searchIndex = label.toLowerCase().indexOf(searchValue.toLowerCase());
  
      if (searchIndex === -1) {
        return label;
      }
      return (
        <>
          {label.substring(0, searchIndex)}
          <span style={{ fontWeight: "600", color: "rgb(254, 184, 83)" }}>
            {label.substring(searchIndex, searchIndex + searchValue.length)}
          </span>
          {label.substring(searchIndex + searchValue.length)}
        </>
      );
    };
  
    const getType = (index: number) => {
      if (index < options.length) return "university";
      else if (index < options.length + disciplines.length) return "discipline";
      else return "subDiscipline";
    };
  
    const handleMouseLeave = (event?: MouseEvent) => {
      if (
        listRef?.current &&
        event &&
        !listRef?.current?.contains(event.target as Node)
      ) {
        setOptions([]);
        setCourseOptions([]);
        setDisciplines([]);
        setsubDisciplines([]);
        setCountry([]);
        setState([]);
        setCity([]);
      }
    };
  
    useEffect(() => {
      document.addEventListener("click", handleMouseLeave);
      return () => {
        document.removeEventListener("click", handleMouseLeave);
      };
    }, []);
  
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {search && window.innerWidth >= 600 ?
          <SearchIcon sx={{ color: { xs: "#fff", md: "#3B3F76" }, cursor: "pointer", fontSize: "1.35rem" }} onClick={() => setSearch(false)} /> :
          <Stack
            direction="row"
            spacing={3}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%"
            }}
          >
            <Box ref={listRef} sx={{ width: "100%" }}>
              <TextField
                placeholder={`Search universities / programs`}
                variant="outlined"
                size="small"
                fullWidth
                autoFocus={true}
                autoComplete="off"
                sx={{
                  width: { xs: "100%", md: "300px", lg: "500px" },
                  marginTop: "8px",
                  position: "relative",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    color: { md: "#3B3F76 !important", xs: "#fff !important" },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: { md: "#3B3F76 !important", xs: "#fff !important" },
                  },
                  "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder": {
                    color: { md: "#3B3F76 !important", xs: "#fff !important" },
                    fontSize: "14px"
                  },
                  "& .MuiFormControl-root": {
                    width: "100% !important"
                  }
                }}
                onFocus={() => eventHandler({ name: "focus", data: "" })}
                value={searchValue}
                onKeyPress={(event) => {
                  const charCode = event.key;
                  const regex = /^[a-zA-Z0-9 ]+$/;
                  if (!regex.test(charCode)) {
                    event.preventDefault();
                    // console.log(charCode)
                    eventHandler({ name: "keypress", data: event })
                  } else {
                    eventHandler({ name: "keypress", data: event })
                  }
                }}
                // onKeyDown={(event) =>
                //   eventHandler({ name: "keydown", data: event })
                // }
                onClick={(event) =>
                  eventHandler({ name: "clicksearch", data: event })
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start" sx={{ display: { xs: "none", md: "flex", alignItems: "center" } }}>
                      <CloseIcon onClick={() => setSearch(true)} sx={{ color: "#3B3F76", cursor: "pointer" }} />
                    </InputAdornment>
                  ),
                }}
                onChange={(event) =>
                  eventHandler({ name: "inputChange", data: event })
                }
              />
              {(options.length > 0 ||
                courseoptions?.length > 0 ||
                disciplines?.length > 0 ||
                subDisciplines?.length > 0 || country?.length > 0 || city?.length > 0 || state?.length > 0) &&
                menuOpen && (
                  <Paper sx={{}}>
                    <List
                      sx={{
                        maxHeight: 400,
                        overflow: "auto",
                        position: "absolute",
                        zIndex: 1,
                        background: "#fff !important",
                        width: "850px",
                        boxShadow: 12,
                        padding: "1rem",
                        height: { xs: "100%", md: "auto" },
                        left: { md: "10%", lg: "unset" }
                      }}
  
                    >
                      <Grid container>
                        {options.length > 0 && (
                          <Grid item xs={12} md={4} >
                            {options.length > 0 ? (
                              <Typography gutterBottom
                                sx={{
                                  pl: 1,
                                  // color: {xs:"#fff",md:"#000"},
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Universities
                              </Typography>
                            ) : (
                              ""
                            )}
                            {options.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "optionChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.type === "university" && selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
                              >
                                <img
                                  src={option ? option?.logoSrc : ""}
                                  alt="icon"
                                  style={{ height: "25px", width: "25px", borderRadius: "10px" }}
                                />
                                {/* <ListItemText
                                primary={renderOption(option)}
                                secondary={renderOption(option?.location?.city)+"," +renderOption(option?.location?.country)}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: "14px !important",
                                  },
                                  "& .MuiTypography-body2":{
                                    fontSize:"12px !important",
                                    color:"rgb(122 118 118 / 60%)"
                                  },
                                  pl: 1,
                                }}
                              /> */}
                                <Box sx={{ ml: 1.5 }}>
                                  <Typography fontSize="14px" >{renderOption(option)}</Typography>
                                  <Typography fontSize="12px" color="rgb(122 118 118 / 60%)">
                                    {/* {renderOption(option?.location?.state)||renderOption(option?.location?.city)}, {renderOption(option?.location?.country)} */}
                                    {searchValue && (
                                      <>
                                        {option?.location?.state?.toLowerCase().includes(searchValue.toLowerCase())
                                          ? renderOption(option?.location?.state)
                                          : option?.location?.city?.toLowerCase().includes(searchValue.toLowerCase())
                                            ? renderOption(option?.location?.city)
                                            : null
                                        }
                                      </>
                                    )}
                                    &nbsp; {renderOption(option?.location?.country)}
                                  </Typography>
                                </Box>
  
                              </ListItemButton>
                            ))}
                          </Grid>
                        )}
  
                        {(disciplines.length > 0 || subDisciplines.length > 0) && (
                          <Grid item xs={12} md={4} >
                            {disciplines.length > 0 || subDisciplines.length > 0 ? (
                              <Typography gutterBottom
                                sx={{
                                  pl: 1,
                                  // color: "#3B3F76",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  // color:{xs:"#fff",md:"#000"}
                                }}
                              >
                                Courses
                              </Typography>
                            ) : (
                              ""
                            )}
                            {disciplines?.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "disciplineChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
  
                              >
                                <ListItemText
                                  primary={renderOption(option)}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontSize: "14px !important",
                                      // color:{xs:"#fff",md:"#000"}
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                            {subDisciplines?.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "subDisciplineChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
                              >
                                <ListItemText
                                  primary={renderOption(option)}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontSize: "14px !important",
                                      // color:{xs:"#fff",md:"#000"}
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Grid>
                        )}
  
                        {country.length > 0 && (
                          <Grid item xs={12} md={4} >
                            {country.length > 0 ? (
                              <Typography gutterBottom
                                sx={{
                                  pl: 1,
                                  // color:{xs:"#fff",md:"#000"},
                                  fontSize: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                Country
                              </Typography>
                            ) : (
                              ""
                            )}
                            {country.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "countryChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
                              >
                                <ListItemText
                                  primary={renderOption(option)}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontSize: "14px !important",
                                      // color:{xs:"#fff",md:"#000"}
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Grid>
                        )}
                        {state.length > 0 && (
                          <Grid item xs={12} md={4} >
                            {state.length > 0 ? (
                              <Typography gutterBottom
                                sx={{
                                  pl: 1,
                                  // color:{xs:"#fff",md:"#000"},
                                  fontSize: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                State
                              </Typography>
                            ) : (
                              ""
                            )}
                            {state.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "stateChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
                              >
                                <ListItemText
                                  primary={renderOption(option)}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontSize: "14px !important",
                                      // color:{xs:"#fff",md:"#000"}
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Grid>
                        )}
                        {city.length > 0 && (
                          <Grid item xs={12} md={4} >
                            {city.length > 0 ? (
                              <Typography gutterBottom
                                sx={{
                                  pl: 1,
                                  // color:{xs:"#fff",md:"#000"},
                                  fontSize: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                City
                              </Typography>
                            ) : (
                              ""
                            )}
                            {city.map((option, index) => (
                              <ListItemButton
                                key={index}
                                onClick={() =>
                                  eventHandler({
                                    name: "cityChange",
                                    data: option,
                                  })
                                }
                                sx={{
                                  pt: 0, pb: 0.5,
                                  backgroundColor: selectedIndex.index === index ? "rgba(0, 0, 0, 0.08)" : "inherit"
                                }}
                              >
                                <ListItemText
                                  primary={renderOption(option)}
                                  sx={{
                                    "& .MuiTypography-root": {
                                      fontSize: "14px !important",
                                      // color:{xs:"#fff",md:"#000"}
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </Grid>
                        )}
  
                      </Grid>
                    </List>
                  </Paper>
                )}
            </Box>
          </Stack>}
      </div>
    );
  };
  
  export default Search;
  